import React from "react"
import { Box, Text } from "rebass"

import Reveal from "../reveals"
import RowWrapper from "./RowWrapper"

import Card from "./RowCardsCard"

const RowCardsComponent = ({ data }) => {
  const { title, titleHeadingTag, text, revealAnimation, cards } = data

  return (
    <RowWrapper {...data}>
      <React.Fragment>
        <Box
          as="header"
          justifyContent="center"
          flexDirection="column"
          px={['15px',null,5]}
          pb={[4,null,null,5]}
        >
          {title && <Text as={titleHeadingTag}>{title}</Text>}
          {text && <Box dangerouslySetInnerHTML={{ __html: text }} />}
        </Box>

        {cards && (
          <Box
            sx={{
              display: "grid",
              gridGap: [5],
              gridTemplateColumns: [
                "repeat(1, minmax(128px, 1fr))",
                "repeat(2, minmax(128px, 1fr))",
              ],
            }}
          >
            {cards.map((card, index) => {
              return (
                <Reveal key={index} delay={0.15 * index} animation={revealAnimation}>
                  <Card index={index} data={card} />
                </Reveal>
              )
            })}
          </Box>
        )}
      </React.Fragment>
    </RowWrapper>
  )
}

export default RowCardsComponent
